import { createUseStyles } from 'react-jss'

export default createUseStyles({
  squareLogo: {
    maxHeight: 230,
    maxWidth: 230,
    margin: '0 auto 24px',

    '& img': {
      maxHeight: '100%',
      maxWidth: '100%'
    }
  }
})
